enum VueModalPopUpButtonTextEnum {
  Save = 0,
  Delete = 1,
  Cancel = 2,
  Update = 3,
}
export default Object.freeze(VueModalPopUpButtonTextEnum);

